import SuspenseWrapper from '@monofe/ui-common/misc/SuspenseWrapper';
import { Fragment } from 'react';
import loader from '../common/loader';
import type {
    IAudioSiteObjectViewModel,
    IBrowseSiteObjectViewModel,
    IHTMLSiteObjectViewModel,
    IRubawaySiteObjectViewModel,
    ISiteObjectIndexProps as ISiteObjectIndexProperties,
    IVideoSiteObjectViewModel,
} from './interface';
import { ISiteObjectType } from './interface';

const MainViewAudio = loader(() => import('./audio'));
const MainViewVideo = loader(() => import('./video'));
const MainViewHTML = loader(() => import('./html'));
const MainViewRubaway = loader(() => import('./rubaway'));
const MainViewBrowse = loader(() => import('./browse'));

function AudioView(properties: ISiteObjectIndexProperties): JSX.Element {
    return (
        <SuspenseWrapper fallback={null}>
            <MainViewAudio {...properties} model={properties.model as IAudioSiteObjectViewModel} />
        </SuspenseWrapper>
    );
}

function VideoView(properties: ISiteObjectIndexProperties): JSX.Element {
    return (
        <SuspenseWrapper fallback={null}>
            <MainViewVideo {...properties} model={properties.model as IVideoSiteObjectViewModel} />
        </SuspenseWrapper>
    );
}

function HTMLView(properties: ISiteObjectIndexProperties): JSX.Element {
    return (
        <SuspenseWrapper fallback={null}>
            <MainViewHTML {...properties} model={properties.model as IHTMLSiteObjectViewModel} />
        </SuspenseWrapper>
    );
}

function RubawayView(properties: ISiteObjectIndexProperties): JSX.Element {
    return (
        <SuspenseWrapper fallback={null}>
            <MainViewRubaway
                {...properties}
                model={properties.model as IRubawaySiteObjectViewModel}
            />
        </SuspenseWrapper>
    );
}

function BrowseView(properties: ISiteObjectIndexProperties): JSX.Element {
    return (
        <SuspenseWrapper fallback={null}>
            <MainViewBrowse
                {...properties}
                model={properties.model as IBrowseSiteObjectViewModel}
            />
        </SuspenseWrapper>
    );
}

function IndexView(properties: ISiteObjectIndexProperties): JSX.Element {
    return (
        <Fragment>
            {properties.type === ISiteObjectType.Audio && <AudioView {...properties} />}
            {properties.type === ISiteObjectType.Video && <VideoView {...properties} />}
            {properties.type === ISiteObjectType.Html && <HTMLView {...properties} />}
            {properties.type === ISiteObjectType.Rubaway && <RubawayView {...properties} />}
            {properties.type === ISiteObjectType.Image && <BrowseView {...properties} />}
        </Fragment>
    );
}

export default IndexView;
